"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVENT_ACTIVITY_ERROR = exports.EVENT_ACTIVITY_SUCCESS = exports.EVENT_ACTIVITY_REQUESTED = exports.EVENT_SEARCH_OVERDUE_ERROR = exports.EVENT_SEARCH_OVERDUE_SUCCESS = exports.EVENT_SEARCH_OVERDUE_REQUESTED = exports.EVENT_ANALYTICS_ERROR = exports.EVENT_ANALYTICS_SUCCESS = exports.EVENT_ANALYTICS_REQUESTED = exports.EVENT_EXPORT_ERROR = exports.EVENT_EXPORT_SUCCESS = exports.EVENT_EXPORT_REQUESTED = exports.EVENT_CHANGE_STATUS_ERROR = exports.EVENT_CHANGE_STATUS_SUCCESS = exports.EVENT_CHANGE_STATUS_REQUESTED = exports.EVENT_ADD_UPLOAD_ERROR = exports.EVENT_ADD_UPLOAD_SUCCESS = exports.EVENT_ADD_UPLOAD_REQUESTED = exports.EVENT_ADD_COMMENT_ERROR = exports.EVENT_ADD_COMMENT_SUCCESS = exports.EVENT_ADD_COMMENT_REQUESTED = exports.EVENT_ERROR = exports.EVENT_SUCCESS = exports.EVENT_REQUESTED = exports.SELECTED_EVENT_ID_TO_UPDATE = exports.SELECTED_EVENT_CHANGED = exports.RESET_EVENT_LIST = exports.EVENT_PATCH_ERROR = exports.EVENT_PATCH_SUCCESS = exports.EVENT_PATCH_REQUESTED = exports.EVENT_ADD_ERROR = exports.EVENT_ADD_SUCCESS = exports.EVENT_ADD_REQUESTED = exports.RESET_NEW_EVENTS = exports.EVENT_UPDATE_ERROR = exports.EVENT_UPDATE = exports.RESET_SEARCH_EVENTS = exports.EVENT_SEARCH_ERROR = exports.EVENT_SEARCH_SUCCESS = exports.EVENT_SEARCH_REQUESTED = void 0;
var EVENT_SEARCH_REQUESTED = 'EVENT_SEARCH_REQUESTED';
exports.EVENT_SEARCH_REQUESTED = EVENT_SEARCH_REQUESTED;
var EVENT_SEARCH_SUCCESS = 'EVENT_SEARCH_SUCCESS';
exports.EVENT_SEARCH_SUCCESS = EVENT_SEARCH_SUCCESS;
var EVENT_SEARCH_ERROR = 'EVENT_SEARCH_ERROR';
exports.EVENT_SEARCH_ERROR = EVENT_SEARCH_ERROR;
var RESET_SEARCH_EVENTS = 'RESET_SEARCH_EVENTS';
exports.RESET_SEARCH_EVENTS = RESET_SEARCH_EVENTS;
var EVENT_UPDATE = 'EVENT_UPDATE';
exports.EVENT_UPDATE = EVENT_UPDATE;
var EVENT_UPDATE_ERROR = 'EVENT_UPDATE_ERROR';
exports.EVENT_UPDATE_ERROR = EVENT_UPDATE_ERROR;
var RESET_NEW_EVENTS = 'RESET_NEW_EVENTS';
exports.RESET_NEW_EVENTS = RESET_NEW_EVENTS;
var EVENT_ADD_REQUESTED = 'EVENT_ADD_REQUESTED';
exports.EVENT_ADD_REQUESTED = EVENT_ADD_REQUESTED;
var EVENT_ADD_SUCCESS = 'EVENT_ADD_SUCCESS';
exports.EVENT_ADD_SUCCESS = EVENT_ADD_SUCCESS;
var EVENT_ADD_ERROR = 'EVENT_ADD_ERROR';
exports.EVENT_ADD_ERROR = EVENT_ADD_ERROR;
var EVENT_PATCH_REQUESTED = 'EVENT_PATCH_REQUESTED';
exports.EVENT_PATCH_REQUESTED = EVENT_PATCH_REQUESTED;
var EVENT_PATCH_SUCCESS = 'EVENT_PATCH_SUCCESS';
exports.EVENT_PATCH_SUCCESS = EVENT_PATCH_SUCCESS;
var EVENT_PATCH_ERROR = 'EVENT_PATCH_ERROR';
exports.EVENT_PATCH_ERROR = EVENT_PATCH_ERROR;
var RESET_EVENT_LIST = 'RESET_EVENT_LIST';
exports.RESET_EVENT_LIST = RESET_EVENT_LIST;
var SELECTED_EVENT_CHANGED = 'SELECTED_EVENT_CHANGED';
exports.SELECTED_EVENT_CHANGED = SELECTED_EVENT_CHANGED;
var SELECTED_EVENT_ID_TO_UPDATE = 'SELECTED_EVENT_ID_TO_UPDATE';
exports.SELECTED_EVENT_ID_TO_UPDATE = SELECTED_EVENT_ID_TO_UPDATE;
var EVENT_REQUESTED = 'EVENT_REQUESTED';
exports.EVENT_REQUESTED = EVENT_REQUESTED;
var EVENT_SUCCESS = 'EVENT_SUCCESS';
exports.EVENT_SUCCESS = EVENT_SUCCESS;
var EVENT_ERROR = 'EVENT_ERROR';
exports.EVENT_ERROR = EVENT_ERROR;
var EVENT_ADD_COMMENT_REQUESTED = 'EVENT_ADD_COMMENT_REQUESTED';
exports.EVENT_ADD_COMMENT_REQUESTED = EVENT_ADD_COMMENT_REQUESTED;
var EVENT_ADD_COMMENT_SUCCESS = 'EVENT_ADD_COMMENT_SUCCESS';
exports.EVENT_ADD_COMMENT_SUCCESS = EVENT_ADD_COMMENT_SUCCESS;
var EVENT_ADD_COMMENT_ERROR = 'EVENT_ADD_COMMENT_ERROR';
exports.EVENT_ADD_COMMENT_ERROR = EVENT_ADD_COMMENT_ERROR;
var EVENT_ADD_UPLOAD_REQUESTED = 'EVENT_ADD_UPLOAD_REQUESTED';
exports.EVENT_ADD_UPLOAD_REQUESTED = EVENT_ADD_UPLOAD_REQUESTED;
var EVENT_ADD_UPLOAD_SUCCESS = 'EVENT_ADD_UPLOAD_SUCCESS';
exports.EVENT_ADD_UPLOAD_SUCCESS = EVENT_ADD_UPLOAD_SUCCESS;
var EVENT_ADD_UPLOAD_ERROR = 'EVENT_ADD_UPLOAD_ERROR';
exports.EVENT_ADD_UPLOAD_ERROR = EVENT_ADD_UPLOAD_ERROR;
var EVENT_CHANGE_STATUS_REQUESTED = 'EVENT_CHANGE_STATUS_REQUESTED';
exports.EVENT_CHANGE_STATUS_REQUESTED = EVENT_CHANGE_STATUS_REQUESTED;
var EVENT_CHANGE_STATUS_SUCCESS = 'EVENT_CHANGE_STATUS_SUCCESS';
exports.EVENT_CHANGE_STATUS_SUCCESS = EVENT_CHANGE_STATUS_SUCCESS;
var EVENT_CHANGE_STATUS_ERROR = 'EVENT_CHANGE_STATUS_ERROR';
exports.EVENT_CHANGE_STATUS_ERROR = EVENT_CHANGE_STATUS_ERROR;
var EVENT_EXPORT_REQUESTED = 'EVENT_EXPORT_REQUESTED';
exports.EVENT_EXPORT_REQUESTED = EVENT_EXPORT_REQUESTED;
var EVENT_EXPORT_SUCCESS = 'EVENT_EXPORT_SUCCESS';
exports.EVENT_EXPORT_SUCCESS = EVENT_EXPORT_SUCCESS;
var EVENT_EXPORT_ERROR = 'EVENT_EXPORT_ERROR';
exports.EVENT_EXPORT_ERROR = EVENT_EXPORT_ERROR;
var EVENT_ANALYTICS_REQUESTED = 'EVENT_ANALYTICS_REQUESTED';
exports.EVENT_ANALYTICS_REQUESTED = EVENT_ANALYTICS_REQUESTED;
var EVENT_ANALYTICS_SUCCESS = 'EVENT_ANALYTICS_SUCCESS';
exports.EVENT_ANALYTICS_SUCCESS = EVENT_ANALYTICS_SUCCESS;
var EVENT_ANALYTICS_ERROR = 'EVENT_ANALYTICS_ERROR';
exports.EVENT_ANALYTICS_ERROR = EVENT_ANALYTICS_ERROR;
var EVENT_SEARCH_OVERDUE_REQUESTED = 'EVENT_SEARCH_OVERDUE_REQUESTED';
exports.EVENT_SEARCH_OVERDUE_REQUESTED = EVENT_SEARCH_OVERDUE_REQUESTED;
var EVENT_SEARCH_OVERDUE_SUCCESS = 'EVENT_SEARCH_OVERDUE_SUCCESS';
exports.EVENT_SEARCH_OVERDUE_SUCCESS = EVENT_SEARCH_OVERDUE_SUCCESS;
var EVENT_SEARCH_OVERDUE_ERROR = 'EVENT_SEARCH_OVERDUE_ERROR';
exports.EVENT_SEARCH_OVERDUE_ERROR = EVENT_SEARCH_OVERDUE_ERROR;
var EVENT_ACTIVITY_REQUESTED = 'EVENT_ACTIVITY_REQUESTED';
exports.EVENT_ACTIVITY_REQUESTED = EVENT_ACTIVITY_REQUESTED;
var EVENT_ACTIVITY_SUCCESS = 'EVENT_ACTIVITY_SUCCESS';
exports.EVENT_ACTIVITY_SUCCESS = EVENT_ACTIVITY_SUCCESS;
var EVENT_ACTIVITY_ERROR = 'EVENT_ACTIVITY_ERROR';
exports.EVENT_ACTIVITY_ERROR = EVENT_ACTIVITY_ERROR;